export default __webpack_public_path__ + "static/media/netcarbs@2x.8f46dde4.jpg";